var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Event_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66,2.34v2a.85.85,0,1,0,1.7,0v-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,4.4a.55.55,0,0,0-.55-.55H8.72V4.3a1.21,1.21,0,1,1-2.41,0V3.85H.55A.55.55,0,0,0,0,4.4v7.71a.55.55,0,0,0,.55.55H14.45a.55.55,0,0,0,.55-.55ZM8.39,7.3h5.18a.36.36,0,1,1,0,.71H8.39a.36.36,0,1,1,0-.71Zm-4.82-2A1.43,1.43,0,1,1,2.14,6.77,1.43,1.43,0,0,1,3.57,5.34Zm2.14,5.73H1.43V9.27a.72.72,0,0,1,.71-.71H5a.72.72,0,0,1,.71.71Zm7.86-1.8H8.39a.36.36,0,0,1,0-.71h5.18a.36.36,0,1,1,0,.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.d5a35906b7f58538b87b16fcdffe8650.svg";
export { ForwardRef as ReactComponent };